import RateCell from './RateCell';

export default RateCell;
